<template>
    <div class="shapan-container">
        <div class="shapan" v-for="item in shapanList" :key="item.id" @click="toDetail(item)">
            <div class="content">
                <h1 class="title">{{item.title}}</h1>
                <!-- <h1 class="subTitle">{{item.subTitle}}</h1> -->
            </div>
            <img :src="item.src">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            shapanList: [
                {
                    id: 1,
                    title: '2022虚拟展馆',
                    subTitle: '7月15日上线',
                    src: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/jinrong-3d-2022.png',
                    // url: 'https://izt.eastfair.cn/h5-web/#/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/image/7.15.jpg',
                    // url: 'https://www.3dqiye.com/anli/klyf/jr/21/',
                    url: 'https://www.3dqiye.com/anli/klyf/jr/21/lei/index.html'
                },
                {
                    id: 2,
                    title: '2020虚拟展馆',
                    subTitle: '',
                    src: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/jinrong_3d.png',
                    url: 'https://izt.eastfair.cn/shapan/index.html'
                }
            ]
        }
    },
    methods: {
        toDetail(item) {
            if (!item.url) return
            // window.location.href = item.url
            // window.open(item.url, '_self')
            window.open(item.url, '_blank')
        }
    }
}
</script>

<style scoped>
.shapan-container {
    padding: 16px;
    box-sizing: border-box;
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: #ffffff;
}
.shapan-container .shapan {
    font-size: 0;
    position: relative;
    margin-bottom: 14px;
}
.shapan-container .shapan .content {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    color: #ffffff;
    padding: 0 20px;
    box-sizing: border-box;
}
.shapan-container .shapan .content .title, .shapan-container .shapan .content .subTitle {
  width: 100%;
  font-size: 26px;
  color: #ffffff;
  font-weight: normal;
  text-align: center;
  margin: 0;
}
.shapan-container .shapan img {
    width: 100%;
    height: 160px;
    display: inline-block;
    border-radius: 10px;
}

@media screen and (min-width: 750px) {
    .shapan-container .shapan img {
        height: 290px;
    }
    .shapan-container .shapan .content .title {
        font-size: 32px;
    }
    .shapan-container .shapan .content .subTitle {
        font-size: 32px;
    }
    
}
</style>
